<template>
  <div class="echarts" id="houseecharts"></div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  inject,
  watchEffect,
  nextTick,
  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import * as echarts from "echarts";
import { houseLive } from "@/api/dataAnalysis/housingAnalysis.js";

export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      echartsList: [],
    });
    const refData = toRefs(data);
    const regionInfo = inject("region");
    watchEffect(() => {
      if (regionInfo.regionList) {
        nextTick(() => {
          houseecharts();
        });
      }
    });
    const numberall = async () => {
      const param = {
        regionIds: regionInfo.regionList.toString(),
      };
      const res = await houseLive(param);
      data.echartsList = res.data;
    };
    let myhouseecharts;
    // 第二个饼图
    function _pie2() {
      const dataArr = [];
      for (var i = 0; i < 8; i++) {
        if (i % 2 === 0) {
          dataArr.push({
            name: (i + 1).toString(),
            value: 35,
            itemStyle: {
              normal: {
                color: "rgba(112,180,248,1)",
              },
            },
          });
        } else {
          dataArr.push({
            name: (i + 1).toString(),
            value: 30,
            itemStyle: {
              normal: {
                color: "rgba(0,0,0,0)",
              },
            },
          });
        }
      }
      return dataArr;
    }
    // color: ['#3d8eb7', '#5dc8d8', '#ecab3c', '#ded747', '#67c99c', '#97b939'],
    const colorList = ["#3d8eb7", "#5dc8d8", "#ecab3c"];
    const houseecharts = async () => {
      await numberall();
      myhouseecharts = echarts.init(document.getElementById("houseecharts"));
      const option = {
        title: {
          text: "实有房屋",
          x: "center",
          y: "center",
          textStyle: {
            fontSize: 13,
            color: "#facd2b",
          },
        },
        color: colorList,
        tooltip: {
          trigger: "item",
          formatter: "{b}:{c} ({d}%)",
        },

        series: [
          {
            name: "租房占比",
            type: "pie",
            radius: ["20%", "45%"],
            center: ["50%", "50%"],
            data: data.echartsList,
            // data: [
            //   { value: 30, name: '居民用水' },
            //   { value: 15, name: '特殊用水' },
            //   { value: 55, name: '经营性用水' }
            // ],
            label: {
              normal: {
                color: "#fff",
                formatter: (params) => {
                  return (
                    "{name|" +
                    params.name +
                    "}" +
                    " " +
                    "{percent|" +
                    params.percent.toFixed(2) +
                    "}" +
                    "%\n{hr|}"
                  );
                },
                padding: [0, -5, 25, -5],
                rich: {
                  name: {
                    fontSize: 13,
                    lineHeight: 25,
                  },
                  percent: {
                    fontSize: 14,
                  },
                  hr: {
                    // 中间线
                    borderColor: "#46e6c3",
                    width: "100%",
                    borderWidth: 1,
                    height: 0,
                  },
                },
              },
            },
            labelLine: {
              length: 33,
              length2: 0,
              lineStyle: {
                color: "#46e6c3",
                width: 2,
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
          {
            type: "pie",
            zlevel: 2,
            silent: true,
            center: ["50%", "50%"],
            radius: ["50%", "53%"],
            startAngle: 50,
            hoverAnimation: false,
            label: {
              normal: {
                show: false,
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: _pie2(),
          },
          {
            type: "pie",
            zlevel: 3,
            silent: true,
            center: ["50%", "50%"],
            radius: ["50%", "51%"],
            label: {
              normal: {
                show: false,
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: _pie2(),
          },
        ],
      };

      //   option && data.myChart.setOption(option);
      //   data.myChart.on('click', function(params) {
      //     context.emit('dialogSate', true); ;
      //   });
      // };
      myhouseecharts.setOption(option);
    };
    onMounted(() => {
      window.addEventListener("resize", () => {
        myhouseecharts.resize();
      });
    });

    return { ...refData };
  },
});
</script>
<style lang="scss" scoped>
#houseecharts {
  width: 100%;
  height: 90%;
}
</style>
